import { render } from "./CustomDomainRibbon.vue?vue&type=template&id=b9507446"
import script from "./CustomDomainRibbon.vue?vue&type=script&lang=js"
export * from "./CustomDomainRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__